import { SvgIcon, SvgIconProps } from '@mui/material';

export const DeliveryEstimateTimeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M10.832 2.16797H15.1654'
          stroke='white'
          strokeWidth='2.16667'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13 15.168L16.25 11.918'
          stroke='white'
          strokeWidth='2.16667'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.9987 23.8333C17.7852 23.8333 21.6654 19.9531 21.6654 15.1667C21.6654 10.3802 17.7852 6.5 12.9987 6.5C8.21223 6.5 4.33203 10.3802 4.33203 15.1667C4.33203 19.9531 8.21223 23.8333 12.9987 23.8333Z'
          stroke='white'
          strokeWidth='2.16667'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  );
};
